class DetailsDisclosure extends HTMLElement
{
    constructor( )
    {
        super( );
        this.disclosure = this.querySelector( 'details' );
        this.toggle = this.querySelector( 'summary' );
        this.panel = this.toggle.nextElementSibling;
        this.init( );
    }

    init( )
    {
        // Check if the content element has a CSS transition.
        if ( window.getComputedStyle( this.panel ).transitionDuration !== '0s' )
        {
            this.toggle.addEventListener( 'click', this.handleToggle.bind( this ) );
            this.disclosure.addEventListener( 'transitionend', this.handleTransitionEnd.bind( this ) );
        }
    }

    /**
     * Handles 'click' events on the summary element.
     * @param { object } evt - Event object.
     */
    handleToggle( evt )
    {
        evt.preventDefault( );

        if ( !this.disclosure.open )
        {
            this.open( );
        }
        else
        {
            this.close( );
        }
    }

    /**
     * Handles 'transitionend' events on the details element.
     * @param { object } evt - Event object.
     */
    handleTransitionEnd( evt )
    {
        if ( evt.target !== this.panel ) return;

        if ( this.disclosure.classList.contains( 'is-closing' ) )
        {
            this.disclosure.classList.remove( 'is-closing' );
            this.disclosure.open = false;
        }

        this.panel.removeAttribute( 'style' );
    }

    /**
     * Adds inline 'height' style to the content element, to trigger open transition.
     */
    addContentHeight()
    {
        this.panel.style.height = `${ this.panel.scrollHeight }px`;
    }

    /**
     * Opens the details element.
     */
    open( )
    {
        // Set content 'height' to zero before opening the details element.
        this.panel.style.height = '0';

        // Open the details element
        this.disclosure.open = true;

        // Set content 'height' to its scroll height, to enable CSS transition.
        this.addContentHeight( );
    }

    /**
     * Closes the details element.
     */
    close( )
    {
        // Set content height to its scroll height, to enable transition to zero.
        this.addContentHeight ();

        // Add class to enable styling of content or toggle icon before or during close transition.
        this.disclosure.classList.add( 'is-closing' );

        // Set content height to zero to trigger the transition.
        // Slight delay required to allow scroll height to be applied before changing to '0'.
        setTimeout( ( ) =>
        {
            this.panel.style.height = '0';
        } );
    }
}

if ( !customElements.get( "details-disclosure" ) )
{
    customElements.define( 'details-disclosure', DetailsDisclosure );
}